module.exports = "\n<jhi-select [id]=\"'civilite'\" name=\"civilite\" label=\"{{ isForMoraleIdentity ? 'Civilité du représentant' : 'Civilité' }}\" hiddenOptionLabel=\"Choisir une civilité\"\n  [(ngModel)]=\"value\" [disabled]=\"disabled\" [required]=\"isRequired\">\n  <jhi-option [value]=\"civility\" *ngFor=\"let civility of civilities\">{{civility}}</jhi-option>\n</jhi-select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/identite-personne/civilite/civilite.component.html
// module id = 852
// module chunks = 0